import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { message } from 'antd'

import JobOfferModel from './JobOfferModel'
import JobApplicantNotes from './JobApplicantNotes'
import JobApplicantResume from './JobApplicantResume'
import JobApplicantInfoCard from './JobApplicantInfoCard'
import JobApplicantPersonalDetails from './JobApplicantPersonalDetails'

// store
import { profileState } from '../../profile/profile.slice'
import { apiUpdateJobApplicationStatus } from '../store/jobApplicant.service'
import {
    getJobApplicantListByStatus,
    getStatusWiseCount,
} from '../store/jobApplicant.slice'

const initialJobApplicationState = {
    status: null,
    jobOfferModalOpen: false,
    jobOfferModalData: null,
}

const JobApplicantDetails = ({ state, setState }) => {
    const dispatch = useDispatch()
    const params = useParams()

    const [JobApplicationState, setJobApplicationState] = useState(
        initialJobApplicationState
    )

    const { profileData } = useSelector(profileState)

    useEffect(() => {
        if (profileData) {
            setJobApplicationState((prevState) => ({
                ...prevState,
                status: profileData?.data?.status,
            }))
        }
    }, [profileData])

    const handleUpdateJobApplicationStatus = async (event) => {
        try {
            // if (event !== 'offered') {
            const updateRes = await apiUpdateJobApplicationStatus({
                candidateId: state?.selectedApplicantData?.candidateId,
                status: event,
                jobId: params?.id,
            })

            if (updateRes?.data?.success) {
                dispatch(getStatusWiseCount({ jobId: params.id }))
                dispatch(
                    getJobApplicantListByStatus({
                        filter: {
                            status: JobApplicationState?.status,
                            job: params.id,
                        },
                    })
                )
                // dispatch(
                //     updateUserGet({
                //         _id: profileData?.data?._id,
                //     })
                // )
                setJobApplicationState((prevState) => ({
                    ...prevState,
                    status: event,
                }))
                message.success('Job Application status updated successfully')
            }
            // }
            // else {
            //     setJobApplicationState((prevState) => ({
            //         ...prevState,
            //         status: event,
            //         jobOfferModalOpen: true,
            //     }))
            // }
        } catch (error) {
            console.log(error)
        }
    }

    const handleViewAndUpdateResume = () => {
        setState((prevState) => ({
            ...prevState,
            jobApplicantResumeDrawer: true,
        }))
    }

    const handleViewNotes = () => {
        setState((prevState) => ({
            ...prevState,
            jobApplicantNotesDrawer: true,
        }))
    }

    return (
        <>
            <div>
                <JobApplicantInfoCard
                    state={state}
                    setState={setState}
                    handleUpdateJobApplicationStatus={
                        handleUpdateJobApplicationStatus
                    }
                    JobApplicationState={JobApplicationState}
                    handleViewAndUpdateResume={handleViewAndUpdateResume}
                    handleViewNotes={handleViewNotes}
                />

                <JobApplicantPersonalDetails />
            </div>

            <JobOfferModel
                state={JobApplicationState}
                setState={setJobApplicationState}
            />

            <JobApplicantResume state={state} setState={setState} />

            <JobApplicantNotes
                state={state}
                setState={setState}
                JobApplicationState={JobApplicationState}
                handleUpdateJobApplicationStatus={
                    handleUpdateJobApplicationStatus
                }
            />
        </>
    )
}

export default JobApplicantDetails
